import { BubbleTextProps } from "@totalenergiescode/mobility-business-rev-design-system";
import { match } from "ts-pattern";

import { FullNameProps } from "@/api/graphql/notifications/types.ts";
import {
  NotificationsMsSearchNotificationsResponseDataFailedReason,
  NotificationsMsSearchNotificationsResponseDataStatus,
} from "@/api/graphql/types/graphql.ts";
import { capitalizeFirstLetter } from "@/utils/strings/capitalizeFirstLetter/util.ts";

export const getStatusAndColor = ({
  status,
  failedReason,
  tNotifications,
}: {
  status: NotificationsMsSearchNotificationsResponseDataStatus;
  failedReason: NotificationsMsSearchNotificationsResponseDataFailedReason | "";
  tNotifications: (key: string) => string;
}): { translatedStatus: string; color: BubbleTextProps["variant"] } =>
  match({ status, failedReason })
    .with(
      { status: NotificationsMsSearchNotificationsResponseDataStatus.New },
      () => ({
        translatedStatus: tNotifications("notifications.status.NEW"),
        color: "orange" as BubbleTextProps["variant"],
      }),
    )
    .with(
      {
        status: NotificationsMsSearchNotificationsResponseDataStatus.Handled,
        failedReason: "",
      },
      () => ({
        translatedStatus: tNotifications("notifications.status.HANDLED"),
        color: "green" as BubbleTextProps["variant"],
      }),
    )
    .otherwise(() => ({
      translatedStatus: tNotifications("notifications.status.ERROR"),
      color: "red" as BubbleTextProps["variant"],
    }));

export const getFullName = ({
  firstName,
  lastName,
  tNotifications,
}: FullNameProps) => {
  const normalizedFirstName = capitalizeFirstLetter(firstName?.trim());
  const normalizedLastName = lastName?.trim().toUpperCase() || undefined;

  return match({
    code: normalizedFirstName,
    name: normalizedLastName,
  })
    .with({ code: undefined, name: undefined }, () =>
      tNotifications("notifications.dataNotAvailable"),
    )
    .with({ code: undefined }, () => `${normalizedLastName}`)
    .with({ name: undefined }, () => `${normalizedFirstName}`)
    .otherwise(() => `${normalizedFirstName} - ${normalizedLastName}`);
};
